/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Feedbacktalkcompletedat2Inputs */

const de__field_feedbacktalkcompletedat2 = /** @type {(inputs: _Field_Feedbacktalkcompletedat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback-Gespräch absolviert am`)
};

/**

* @param {_Field_Feedbacktalkcompletedat2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_feedbacktalkcompletedat2 = /** @type {((inputs?: _Field_Feedbacktalkcompletedat2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Feedbacktalkcompletedat2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_feedbacktalkcompletedat2(inputs)
});
export { _field_feedbacktalkcompletedat2 as "_field_feedbacktalkCompletedAt" }